export default __webpack_public_path__ + "static/media/M1A_8.36d49a60.png";